import { Spinner } from '../Spinner/Spinner';

import * as styles from './PageSpinner.module.scss';

function PageSpinner() {
  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
}

export { PageSpinner };
